var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.237,
    height: 18.936,
    viewBox: "0 0 10.237 18.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo_1_",
    "data-name": "facebook-logo (1)",
    transform: "translate(-22.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M31.929 0h-2.455a4.312 4.312 0 0 0-4.542 4.66v2.149h-2.469a.386.386 0 0 0-.386.386v3.113a.386.386 0 0 0 .386.386h2.469v7.856a.386.386 0 0 0 .386.386h3.222a.386.386 0 0 0 .386-.386v-7.855h2.887a.386.386 0 0 0 .386-.386V7.2a.386.386 0 0 0-.386-.386h-2.887V4.987c0-.875.209-1.32 1.349-1.32h1.654a.386.386 0 0 0 .386-.386V.39a.386.386 0 0 0-.386-.39z",
    className: "cls-1",
    "data-name": "Path 60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.370e922b.svg";
export { ForwardRef as ReactComponent };